
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class McHeaderTests extends Vue {

    created() {
    }

    mounted() {
    }
  }
